import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'
import { ContentAnalysisListResponse } from 'src/services/contentAnalysisApi/interfaces/contentAnalysis.interface'

interface UseGetContentAnalysisListParams {
  fromDate?: string
  toDate?: string
}

const fetchContentAnalysisList = async (
  params: UseGetContentAnalysisListParams
): Promise<ContentAnalysisListResponse> => {
  return ContentAnalysisApiService.getList(params)
}

export const useGetContentAnalysisListQuery = (
  params: UseGetContentAnalysisListParams = {}
) => {
  return useQuery({
    placeholderData: keepPreviousData,
    queryFn: () => fetchContentAnalysisList(params),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_LIST,
      params.fromDate,
      params.toDate,
    ],
  })
}
